/**
 * @generated SignedSource<<1dc14b0137f4d052840c21725158aaa6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AtlassianAccountUserFragment$data = {
  readonly accountId: string;
  readonly accountStatus: AccountStatus;
  readonly email: string | null;
  readonly id: string;
  readonly name: string;
  readonly nickname: string | null;
  readonly picture: any;
  readonly " $fragmentType": "AtlassianAccountUserFragment";
};
export type AtlassianAccountUserFragment$key = {
  readonly " $data"?: AtlassianAccountUserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AtlassianAccountUserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AtlassianAccountUserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    }
  ],
  "type": "AtlassianAccountUser",
  "abstractKey": null
};

(node as any).hash = "6c8ca116d302edee37d5021284c14ba5";

export default node;
